import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import './lib/leafletDefaults';

const root = createRoot(document.getElementById('root'));
root.render(<App />);
